<script lang="ts" setup>
import { computed } from 'vue'
import { ChangeKid } from '@brighterly/lib-lumee-ui'

import type { ChangeKidItem } from '@brighterly/lib-lumee-ui'

import { useKidStore } from '@stores/kid'

import { useKidsMenu } from '@hooks/menu/kids-menu.hook'

import qaConfig from '@config/qa.json'
import { getKidAvatarColor, getKidAvatarText } from '@helpers/kid-avatar'

defineOptions({
  name: 'KidSwitcher',
})

const kidStore = useKidStore()

const {
  kids,
  setRedirect,
} = useKidsMenu()

// The app's avatar text and five-hue cycle, not ChangeKid's seven-hue default.
const items = computed<ChangeKidItem<number>[]>(() => kids.value.map((kid, index) => ({
  value: kid.id,
  name: kid.name,
  initials: getKidAvatarText(kid.name),
  color: getKidAvatarColor(index),
})))

const setKid = (id: number | undefined): void => {
  const kid = kids.value.find(item => item.id === id)
  if (kid) setRedirect(kid)
}
</script>

<template>
  <ChangeKid
    :items="items"
    :model-value="kidStore.activeKidId ?? undefined"
    title="Child’s profile"
    :data-qa="qaConfig.attributes.kidSwitcher"
    @update:model-value="setKid"
  />
</template>
